const Theme = {
  logo_image_url: 'cultur3r.png',
  logo_height: 115,

  body_background_color: 'black',

  button_color: 'black',

  text_font: `'Rubik', sans-serif`,
  text_color: 'black',
  title_font: `'Kanit', sans-serif`,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export default Theme
